(function () {
    'use strict';

    angular
        .module('app')
        .controller('approvalauth', approvalauth);

    approvalauth.$inject = ['$location', 'approvalAuthService', 'loginService', '$localStorage', '$rootScope', '$state', '$timeout', '$mdDialog']; 

    function approvalauth($location, approvalAuthService, loginService, $localStorage, $rootScope, $state, $timeout, $mdDialog) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = loginService.resourceStrings['APPROVAL_AUTHENTICATION'];
        vm.userName = $localStorage.userInfo.userName;
        vm.userLogin = $localStorage.userInfo.loginName;
        vm.password = '';

        activate();

        vm.loginService = loginService;

        function activate() { }

        vm.error = "";

        var maximumPasswordAttemptsAllowed = 3;

        var retryAttempts = 0;

        vm.onOk = function() {
            vm.error = '';
            approvalAuthService.authenticate({ userName: vm.userLogin, password: vm.password }).then(function (params) {
                approvalAuthService.close('valid');
            }, function (error) {
                if (error.Message === "InvalidPassword") {
                    retryAttempts++;
                    if (retryAttempts === maximumPasswordAttemptsAllowed) {
                        
                        approvalAuthService.close('cancel');
                        $mdDialog.hide();
                        loginService.logOut().then(function() {
                            $state.go('login', { force: true }).then(function() {
                                $timeout(function() {
                                    $rootScope.msgBoxShow(loginService.resourceStrings['MAXIMUM_PASSWORD_RETRIES_REACHED'].replace("{0}",maximumPasswordAttemptsAllowed), vm.title, 3);
                                }, 250);                                
                            });
                        });
                    }
                    vm.error = loginService.resourceStrings["INVALID_PASSWORD"];
                }
                else {
                    vm.error = error.Message;
                }
            });
        }

        vm.close = function () {
            approvalAuthService.close('cancel');
        }

        vm.onPassKeyDown = function(event) {
            if (event.keyCode === 13 && vm.password !== '') {
                vm.onOk();
            }
        }

        vm.inputChanged = function() {
            vm.error = "";
        }

    }
})();